/**
 * @property waiting 결제 대기 중
 * @property paid 결제됨
 * @property withdraw 결제 취소됨
 */
export enum PaymentStatus {
    WAITING = 'waiting',
    PAID = 'paid',
    WITHDRAW = 'withdraw',
}
